
// material-ui

// project imports

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
  <img
    src="https://product.influencer.in/static/media/logo.9bfbfb27.png"
    alt="INFLUENCER"
    height={30}
  />
);

export default LogoSection;
